import React, { useCallback, useState } from "react";
import { Button, Icon, ModalDialog, TextField, Success, PlainButton } from "@culturehq/components";

import { Trans } from "app/utils";
import getSubdomain from "app/utils/getSubdomain";
import ChqModalDialog from "components/common/ChqModalDialog";

const EMBBED_CODE = "<div style=\"left: 0; width: 100%; height: 0; position: relative; padding-bottom: 56.25%;\"><iframe src=\"https://SUBDOMAIN.culturehq.com/story/STORY_ID\" style=\"top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0;\" allowfullscreen scrolling=\"no\" allow=\"encrypted-media;\"></iframe></div>";

const replaceEmbbededCode = storyId => EMBBED_CODE.replace("STORY_ID", storyId).replace("SUBDOMAIN", getSubdomain());

const EmbedStoryCode = ({
  story, onClose: onCloseMenu, onOpenChildren
}) => {
  const [copied, setCopied] = useState(false);
  const [open, setOpen] = useState(false);
  const [embeddableCode] = useState(replaceEmbbededCode(story.id));

  const onOpen = useCallback(() => {
    setOpen(true);
    if (onOpenChildren) onOpenChildren();
  }, [onOpenChildren, setOpen]);

  const onClose = useCallback(
    () => {
      setCopied(false);
      setOpen(false);
      if (onCloseMenu) onCloseMenu();
    },
    [onCloseMenu, setCopied, setOpen]
  );

  const onCopy = useCallback(
    () => {
      document.querySelector("#embeddable_code").select();
      document.execCommand("copy");
      setCopied(true);
    },
    [setCopied]
  );

  return (
    <>
      <PlainButton onClick={onOpen}>
        <Icon icon="code" /><Trans>Embed</Trans>
      </PlainButton>
      {open && (
        <ChqModalDialog onClose={onClose} className="EmbedStories">
          <ModalDialog.Heading onClose={onClose}>
            <Trans>Embed Story in an Iframe</Trans>
          </ModalDialog.Heading>
          <ModalDialog.Body>
            <div className="TipContainer">
              <Icon icon="lightbulb" />
              <div>
                <p>
                  <Trans>
                    <strong>Tip:</strong> Use this to display a responsive story iframe right
                    on your site. Copy the code below and paste it into a code block wherever
                    you want it to display.
                  </Trans>
                </p>
              </div>
            </div>
            <TextField
              readOnly
              rows={3}
              name="embeddable_code"
              value={embeddableCode}
            />
            {copied && (
              <Success>
                <Trans>Embeddable code copied to the clipboard.</Trans>
              </Success>
            )}
            <div className="ButtonContainer">
              <Button icon="copy" primary onClick={onCopy}>
                <Trans>Copy Code</Trans>
              </Button>
            </div>
          </ModalDialog.Body>
        </ChqModalDialog>
      )}
    </>
  );
};

export default EmbedStoryCode;
